<template>
  <div class="h-full">
    <alert />
    <div class="drawer-header d-flex align-center mb-4">
      <span class="font-weight-semibold text-base text--primary">Update Question - {{ localQuestion.valueName }}</span>
      <v-spacer></v-spacer>
      <v-menu
            bottom
            left
            min-width="150"
            v-if="['radiogroup', 'dropdown', 'checkbox'].includes(localQuestion.type)"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                small
                v-bind="attrs"
                v-on="on"
              >
            <v-icon size="22">
              {{ icons.mdiDotsVertical }}
            </v-icon>
              </v-btn>
            </template>

            <v-list>
              <v-subheader >Change Question Type</v-subheader>
              <v-list-item-group
                color="primary"
              >
                <v-list-item
                  @click="localQuestion.type='radiogroup'"
                >
                  <v-list-item-content>
                    <v-list-item-title>Single</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item
                @click="localQuestion.type='checkbox'">
                  <v-list-item-content>
                    <v-list-item-title>Multi</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list-item-group>
            </v-list>
          </v-menu>
    </div>
      <perfect-scrollbar
        :settings="perfectScrollbarSettings"
        class="ps-calendar-event-handler"
        ref="scroller"
      >
        <v-form
          ref="refQuestionHandlerForm"
          class="px-5 pt-3 pb-10"
          @submit.prevent="handleFormSubmit"
        >
          <v-card flat  v-if="localQuestion">
          <v-card-text class="px-0 pt-0">
              <v-text-field
                v-model="localQuestion.name"
                :prefix="questionLabelPrefix"
                label="Label"
                outlined
                hide-details="auto"
                dense
                class="mb-6"
                :disabled="localQuestion.disabled"
                :rules="[validators.required, validators.questionLabelCheck, validators.decipherLabelValidator]"
                @keydown.space.prevent
              ></v-text-field>


              <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <div
                      v-bind="attrs"
                      v-on="on">
                        <editor
                          :modelValue.sync="localQuestion.html[localDefaultLang.code]"
                          :variable-suggestions="variableSuggestions"
                          :stim-suggestions="localStimSuggestions"
                          label="Introduction"
                          :editor.sync="editor"
                          :rules="[validators.required]"
                          @change="onChangeDelOtherLang('html')"
                          class="pt-2"
                          v-if="localQuestion.html"
                        />

                      </div>

                    </template>
                    <span class="tooltip">{{getContentTooltip(localQuestion.html, content, localDefaultLang.code)}}</span>
                  </v-tooltip>
              <div v-if="localQuestion.title">
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <div
                      v-bind="attrs"
                      v-on="on">
                      <editor
                        :modelValue.sync="localQuestion.title[localDefaultLang.code]"
                        :variable-suggestions="variableSuggestions"
                        :stim-suggestions="localStimSuggestions"
                        label="Question"
                        :editor.sync="editor"
                        @change="onChangeDelOtherLang('title')"
                        :rules="[validators.required]"
                      v-if="localQuestion.title"/>
                    </div>

                  </template>
                  <span class="tooltip">{{getContentTooltip(localQuestion.title, content, localDefaultLang.code)}}</span>
                </v-tooltip>
              </div>
              <div v-if="localQuestion.description">
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <div
                      v-bind="attrs"
                      v-on="on">
                        <editor
                            :modelValue.sync="localQuestion.description[localDefaultLang.code]"
                            :variable-suggestions="variableSuggestions"
                            :stim-suggestions="localStimSuggestions"
                            @change="onChangeDelOtherLang('description')"
                            label="Add. Instructions"
                            class="pb-6"
                        />
                    </div>

                  </template>
                  <span class="tooltip">{{getContentTooltip(localQuestion.description, content, localDefaultLang.code)}}</span>
                </v-tooltip>
                </div>
                <datatable
                  :headers="localQuestion.headers"
                  :items="localQuestion.items"
                  @save-headers="save_headers"
                  @save-items="save_items"
                  class="pb-6"
                  v-if="localQuestion.headers && localQuestion.items"
                ></datatable>

              <div v-if="['radiogroup','checkbox','dropdown', 'webshopping'].includes(localQuestion.type)">
                <span class="pt-4 text-subtitle-1 font-weight-bold">Choices</span>
                <v-tooltip bottom v-if="!(localQuestion.static && localQuestion.static.choices)">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                        text
                        icon
                        x-small
                        color="primary"
                        @click="openDialogBox('choices')"
                        v-bind="attrs"
                        v-on="on"
                    >
                    <v-icon
                        color="primary"
                        small
                    >{{ icons.mdiTextBoxEditOutline }}</v-icon>
                    </v-btn>
                  </template>
                  <span class="tooltip">Open list window</span>
                </v-tooltip>
                <v-tooltip bottom v-if="!(localQuestion.static && localQuestion.static.choices)">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                        text
                        icon
                        x-small
                        color="primary"
                        @click="resetCodes('choices')"
                        v-bind="attrs"
                        v-on="on"
                    >
                    <v-icon
                        color="primary"
                        small
                    >{{ icons.mdiCogs }}</v-icon>
                    </v-btn>
                  </template>
                  <span class="tooltip">Reset all codes/values - NOT FOR NORMS</span>
                </v-tooltip>

                <draggable
                  :list="localQuestion.choices"
                  class="list-group"
                  :animation="200"
                  ghost-class="ghost-card"
                  handle=".handle"
                  :force-fallback="true"
              >
              <v-row  v-for="(item, i) in localQuestion.choices"
                :key="i"
                class="ma-0"
              >
                <v-icon class="cursor-pointer handle">{{ icons.mdiMenu }}</v-icon>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="item.text[localDefaultLang.code]"
                        outlined
                        dense
                        hide-details
                        class="pb-2"
                        v-bind="attrs"
                        v-on="on"
                        @change="onChangeDelOtherLang('choices', i)"
                    >

                      <template slot="append">
                        <div class="d-flex justify-center align-center">
                          <span class="text-center">{{item.value}}</span>
                        </div>
                        <v-menu>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                icon
                                x-small
                                v-bind="attrs"
                                v-on="on"
                                >
                              <v-icon>{{ icons.mdiAt }}</v-icon>
                              </v-btn>
                            </template>

                            <v-list dense>
                                <v-list-item
                                    v-for="(variable, suggIdx) in variableSuggestions"
                                    :key="suggIdx"
                                    @click="item.text[localDefaultLang.code] += ` {${variable.label}}`; onChangeDelOtherLang('choices', i)"
                                >
                                    <!-- <v-list-item-title></v-list-item-title> -->
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-list-item-subtitle
                                            v-bind="attrs"
                                            v-on="on">{{ variable.label }}</v-list-item-subtitle>
                                        </template>
                                        <span>{{ variable.value }}</span>
                                    </v-tooltip>
                                </v-list-item>
                            </v-list>
                        </v-menu>

                        <!-- NEW: Stim suggestions menu -->
                        <v-menu>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              icon
                              x-small
                              v-bind="attrs"
                              v-on="on"
                              title="Insert Stim"
                            >
                              <!-- You can choose an icon here, e.g., mdi-image -->
                              <v-icon>{{icons.mdiImagePlusOutline}}</v-icon>
                            </v-btn>
                          </template>

                          
                            <v-list dense max-height="500px" class="overflow-y-auto">
                              <template
                                  v-for="(stim, suggIdx) in localStimSuggestions"
                              >
                              <div
                              :key="suggIdx">
                                <v-subheader v-if="stim.header">{{ stim.header }}</v-subheader>
                                  <v-list-item v-else
                                      @click="item.text[localDefaultLang.code] += ` (${stim.label})`; onChangeDelOtherLang('choices', i)"
                                  >
                                      <!-- <v-list-item-title></v-list-item-title> -->
                                      <v-tooltip bottom>
                                          <template v-slot:activator="{ on, attrs }">
                                              <v-list-item-subtitle
                                              v-bind="attrs"
                                              v-on="on">{{ stim.label }}</v-list-item-subtitle>
                                          </template>
                                          <span>{{ stim.label }}</span>
                                      </v-tooltip>
                                  </v-list-item>
                            </div>
                          </template>
                        </v-list>
                              
                        </v-menu>
                        <v-btn
                            icon
                            x-small
                            @click="removeItem(i, 'choices')"
                            v-if="!(localQuestion.static && localQuestion.static.choices)">
                          <v-icon
                          >{{icons.mdiTrashCanOutline}}</v-icon>
                        </v-btn>
                      </template>
                  </v-text-field>
                  </template>
                  <span class="tooltip">{{getContentTooltip(item.text, content, localDefaultLang.code)}}</span>
                </v-tooltip>
                <v-tooltip top v-if="localQuestion.choicesOrder">
                    <template v-slot:activator="{ on, attrs }">
                        <span
                            v-bind="attrs"
                            v-on="on">
                        <v-checkbox
                            v-model="item.noShuffle"
                            hide-details
                            class="shrink mr-2 mt-0"
                        ></v-checkbox>
                        </span>
                    </template>
                    <span>Do Not Shuffle</span>
                </v-tooltip>
                  <v-tooltip top v-if="localQuestion.type == 'checkbox'">
                      <template v-slot:activator="{ on, attrs }">

                          <span
                              v-bind="attrs"
                              v-on="on">
                          <v-checkbox
                              v-model="item.exclusive"
                              hide-details
                              class="shrink mr-2 mt-0"
                          ></v-checkbox>
                          </span>
                      </template>
                      <span>Exclusive</span>
                  </v-tooltip>

                  <v-tooltip top v-if="localQuestion.type != 'dropdown'">
                      <template v-slot:activator="{ on, attrs }">
                          <span
                              v-bind="attrs"
                              v-on="on">
                          <v-checkbox
                              v-model="item.showOtherItem"
                              hide-details
                              class="shrink mr-2 mt-0"
                          ></v-checkbox>
                          </span>
                      </template>
                      <span>Show Other (Specify)</span>
                  </v-tooltip>
            </v-row>
              </draggable>
                <v-text-field
                  label="Add item"
                  hide-details
                  outlined
                  dense
                  v-model="newChoiceItem"
                  :append-icon="icons.mdiPlus"
                  @keydown.enter.prevent="addItem(newChoiceItem, 'choices')"
                  @click:append="addItem(newChoiceItem, 'choices')"
                  v-if="!(localQuestion.static && localQuestion.static.choices)"
              >
              </v-text-field>
            </div>
            <div v-if="['radiogroup', 'dropdown', 'checkbox'].includes(localQuestion.type)">

              <!-- <v-radio-group
                v-model="localQuestion.type"
                hide-details
                label="Question type"
                row
              >
                <v-radio
                  label="Single"
                  value="radiogroup"
                ></v-radio>
                <v-radio
                  label="Multi"
                  value="checkbox"
                ></v-radio>
              </v-radio-group> -->
              <v-autocomplete
                v-model="localQuestion.choicesFromQuestion"
                :items="questionsWithChoices"
                label="Copy choices from the following question"
                hide-details
                dense
                outlined
                clearable
                placeholder="Select question"
                class="pt-6"
                @change="updateCopyChoice"
              >

              </v-autocomplete>

              <v-radio-group
                v-model="localQuestion.choicesFromQuestionMode"
                label="Which choices to copy"
                row
                class="mt-0"
                v-if="localQuestion.choicesFromQuestion"
                :rules="[validators.requiredArray]"
              >
                    <v-radio
                      label="All"
                      value="all"
                    >
                    </v-radio>
                    <v-radio
                      label="Selected"
                      value="selected"
                    ></v-radio>
                    <v-radio
                      label="Unselected"
                      value="unselected"
                    ></v-radio>
              </v-radio-group>
            </div>


            <div v-if="localQuestion.columns">
              <span class="pt-4 text-subtitle-1 font-weight-bold">Columns</span>
              <v-tooltip bottom v-if="!(localQuestion.static && localQuestion.static.columns)">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                        text
                        icon
                        x-small
                        color="primary"
                        @click="openDialogBox('columns')"
                        v-bind="attrs"
                        v-on="on"
                    >
                    <v-icon
                        color="primary"
                        small
                    >{{ icons.mdiTextBoxEditOutline }}</v-icon>
                    </v-btn>
                  </template>
                  <span class="tooltip">Open list window</span>
                </v-tooltip>
                <v-tooltip bottom v-if="!(localQuestion.static && localQuestion.static.columns)">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                        text
                        icon
                        x-small
                        color="primary"
                        @click="resetCodes('columns')"
                        v-bind="attrs"
                        v-on="on"
                    >
                    <v-icon
                        color="primary"
                        small
                    >{{ icons.mdiCogs }}</v-icon>
                    </v-btn>
                  </template>
                  <span class="tooltip">Reset all codes/values - NOT FOR NORMS</span>
                </v-tooltip>
                <draggable
                      :list="localQuestion.columns"
                      class="list-group"
                      :animation="200"
                      ghost-class="ghost-card"
                      handle=".handle"
                      :force-fallback="true"
                  >
                    <v-row  v-for="(item, i) in localQuestion.columns"
                      :key="i"
                      class="ma-0"
                    >
                    <v-icon class="cursor-pointer handle">{{ icons.mdiMenu }}</v-icon>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                          v-model="item.text[localDefaultLang.code]"
                          outlined
                          dense
                          hide-details
                          class="pb-2"
                          v-bind="attrs"
                          v-on="on"
                          @change="onChangeDelOtherLang('columns', i)"
                          v-if="item.text"
                      >

                      <template slot="append">

                            <div class="d-flex justify-center align-center">
                              <span class="text-center">{{item.value}}</span>
                            </div>
                        <v-menu>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                icon
                                x-small
                                v-bind="attrs"
                                v-on="on"
                                >
                              <v-icon>{{ icons.mdiAt }}</v-icon>
                              </v-btn>
                            </template>

                            <v-list dense>
                                <v-list-item
                                    v-for="(variable, suggIdx) in variableSuggestions"
                                    :key="suggIdx"
                                    @click="item.text[localDefaultLang.code] += ` {${variable.label}}`; onChangeDelOtherLang('columns', i)"
                                >
                                    <!-- <v-list-item-title></v-list-item-title> -->
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-list-item-subtitle
                                            v-bind="attrs"
                                            v-on="on">{{ variable.label }}</v-list-item-subtitle>
                                        </template>
                                        <span>{{ variable.value }}</span>
                                    </v-tooltip>
                                </v-list-item>
                            </v-list>
                        </v-menu>
                        <!-- NEW: Stim suggestions menu -->
                        <v-menu>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              icon
                              x-small
                              v-bind="attrs"
                              v-on="on"
                              title="Insert Stim"
                            >
                              <!-- You can choose an icon here, e.g., mdi-image -->
                              <v-icon>{{icons.mdiImagePlusOutline}}</v-icon>
                            </v-btn>
                          </template>

                          
                            <v-list dense max-height="500px" class="overflow-y-auto">
                              <template
                                  v-for="(stim, suggIdx) in localStimSuggestions"
                              >
                                <div
                                :key="suggIdx">
                                  <v-subheader v-if="stim.header">{{ stim.header }}</v-subheader>
                                    <v-list-item v-else
                                      @click="item.text[localDefaultLang.code] += ` (${stim.label})`; onChangeDelOtherLang('columns', i)"
                                  >
                                      <!-- <v-list-item-title></v-list-item-title> -->
                                      <v-tooltip bottom>
                                          <template v-slot:activator="{ on, attrs }">
                                              <v-list-item-subtitle
                                              v-bind="attrs"
                                              v-on="on">{{ stim.label }}</v-list-item-subtitle>
                                          </template>
                                          <span>{{ stim.label }}</span>
                                      </v-tooltip>
                                  </v-list-item>
                                </div>
                              </template>
                          </v-list>
                        </v-menu>
                        <v-btn
                            icon
                            x-small
                            @click="removeItem(i, 'columns')"
                            v-if="!(localQuestion.static && localQuestion.static.columns)">
                          <v-icon
                          >{{icons.mdiTrashCanOutline}}</v-icon>
                        </v-btn>
                      </template>


                    </v-text-field>
                      <v-text-field
                          v-model="item.title[localDefaultLang.code]"
                          outlined
                          dense
                          hide-details
                          class="pb-2"
                          v-bind="attrs"
                          v-on="on"
                          v-else
                      >

                      <template slot="append">


                        <v-menu>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                icon
                                x-small
                                v-bind="attrs"
                                v-on="on"
                                >
                              <v-icon>{{ icons.mdiAt }}</v-icon>
                              </v-btn>
                            </template>

                            <v-list dense>
                                <v-list-item
                                    v-for="(variable, suggIdx) in variableSuggestions"
                                    :key="suggIdx"
                                    @click="item.title[localDefaultLang.code] += ` {${variable.label}}`"
                                >
                                    <!-- <v-list-item-title></v-list-item-title> -->
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-list-item-subtitle
                                            v-bind="attrs"
                                            v-on="on">{{ variable.label }}</v-list-item-subtitle>
                                        </template>
                                        <span>{{ variable.value }}</span>
                                    </v-tooltip>
                                </v-list-item>
                            </v-list>
                        </v-menu>
                        <!-- NEW: Stim suggestions menu -->
                        <v-menu>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              icon
                              x-small
                              v-bind="attrs"
                              v-on="on"
                              title="Insert Stim"
                            >
                              <!-- You can choose an icon here, e.g., mdi-image -->
                              <v-icon>{{icons.mdiImagePlusOutline}}</v-icon>
                            </v-btn>
                          </template>

                          
                            <v-list dense max-height="500px" class="overflow-y-auto">
                              <template
                                  v-for="(stim, suggIdx) in localStimSuggestions"
                              >
                              <div
                              :key="suggIdx">
                                <v-subheader v-if="stim.header">{{ stim.header }}</v-subheader>
                                  <v-list-item v-else
                                      @click="item.text[localDefaultLang.code] += ` (${stim.label})`"
                                  >
                                      <!-- <v-list-item-title></v-list-item-title> -->
                                      <v-tooltip bottom>
                                          <template v-slot:activator="{ on, attrs }">
                                              <v-list-item-subtitle
                                              v-bind="attrs"
                                              v-on="on">{{ stim.label }}</v-list-item-subtitle>
                                          </template>
                                          <span>{{ stim.label }}</span>
                                      </v-tooltip>
                                  </v-list-item>
                            </div>
                          </template>
                        </v-list>
                              
                        </v-menu>
                        <v-btn
                            icon
                            x-small
                            @click="removeItem(i, 'columns')"
                      v-if="!(localQuestion.static && localQuestion.static.columns)">
                          <v-icon
                          >{{icons.mdiTrashCanOutline}}</v-icon>
                        </v-btn>
                        </template>
                    </v-text-field>
                    </template>
                    <span class="tooltip">{{getContentTooltip(item.text || item.title, content, localDefaultLang.code)}}</span>
                    </v-tooltip>
                  </v-row>
                </draggable>
                <v-text-field
                  label="Add item"
                  hide-details
                  outlined
                  dense
                  v-model="newColumnItem"
                  :append-icon="icons.mdiPlus"
                  @keydown.enter.prevent="addItem(newColumnItem, 'columns')"
                  @click:append="addItem(newColumnItem, 'columns')"
                  class="pb-6"
                  v-if="!(localQuestion.static && localQuestion.static.columns)"
              >
              </v-text-field>
            </div>

            <!----->
            <div v-if="localQuestion.themes">
              <span class="pt-4 text-subtitle-1 font-weight-bold">Themes</span>
              <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                        text
                        icon
                        x-small
                        color="primary"
                        @click="addTheme"
                        v-bind="attrs"
                        v-on="on"
                    >
                    <v-icon
                        color="primary"
                        small
                    >{{ icons.mdiPlus }}</v-icon>
                    </v-btn>
                  </template>
                  <span class="tooltip">Add new theme</span>
                </v-tooltip>
              <div v-for="(theme, themeIndex) in localQuestion.themes"
                :key="themeIndex"
              >
              <v-text-field
                v-model="theme.title[localDefaultLang.code]"
                label="Label"
                outlined
                :rules="[validators.required, validators.questionLabelCheck]"
                hide-details="auto"
                dense
                class="py-2"
                @change="onChangeDelOtherLang('themes', themeIndex)"
              >

              <template slot="append">


                <v-menu>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        icon
                        x-small
                        v-bind="attrs"
                        v-on="on"
                        >
                      <v-icon>{{ icons.mdiAt }}</v-icon>
                      </v-btn>
                    </template>

                    <v-list dense>
                        <v-list-item
                            v-for="(variable, suggIdx) in variableSuggestions"
                            :key="suggIdx"
                            @click="theme.title[localDefaultLang.code] += ` {${variable.label}}`; onChangeDelOtherLang('themes', themeIndex)"
                        >
                            <!-- <v-list-item-title></v-list-item-title> -->
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-list-item-subtitle
                                        v-bind="attrs"
                                        v-on="on">{{ variable.label }}</v-list-item-subtitle>
                                    </template>
                                    <span>{{ variable.value }}</span>
                                </v-tooltip>
                        </v-list-item>
                    </v-list>
                </v-menu>
                <!-- NEW: Stim suggestions menu -->
                <v-menu>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              icon
                              x-small
                              v-bind="attrs"
                              v-on="on"
                              title="Insert Stim"
                            >
                              <!-- You can choose an icon here, e.g., mdi-image -->
                              <v-icon>{{icons.mdiImagePlusOutline}}</v-icon>
                            </v-btn>
                          </template>

                          
                            <v-list dense max-height="500px" class="overflow-y-auto">
                              <template
                                  v-for="(stim, suggIdx) in localStimSuggestions"
                              >
                              <div
                              :key="suggIdx">
                                <v-subheader v-if="stim.header">{{ stim.header }}</v-subheader>
                                  <v-list-item v-else
                                      @click="theme.title[localDefaultLang.code] += ` (${stim.label})`; onChangeDelOtherLang('themes', themeIndex)"
                                  >
                                      <!-- <v-list-item-title></v-list-item-title> -->
                                      <v-tooltip bottom>
                                          <template v-slot:activator="{ on, attrs }">
                                              <v-list-item-subtitle
                                              v-bind="attrs"
                                              v-on="on">{{ stim.label }}</v-list-item-subtitle>
                                          </template>
                                          <span>{{ stim.label }}</span>
                                      </v-tooltip>
                                  </v-list-item>
                            </div>
                          </template>
                        </v-list>
                              
                        </v-menu>
                <v-btn
                    icon
                    x-small
                    @click="removeItem(themeIndex, 'themes')">
                  <v-icon
                  >{{icons.mdiTrashCanOutline}}</v-icon>
                </v-btn>
              </template>

            </v-text-field>
              <v-tooltip bottom v-if="!(theme.static && theme.static.rows)">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                        text
                        icon
                        x-small
                        color="primary"
                        @click="openDialogBox('rows', {name: 'themes', index: themeIndex})"
                        v-bind="attrs"
                        v-on="on"
                    >
                    <v-icon
                        color="primary"
                        small
                    >{{ icons.mdiTextBoxEditOutline }}</v-icon>
                    </v-btn>
                  </template>
                  <span class="tooltip">Open list window</span>
                </v-tooltip>
                <v-tooltip bottom v-if="!(theme.static && theme.static.rows)">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                        text
                        icon
                        x-small
                        color="primary"
                        @click="resetCodes('rows', {name: 'themes', index: themeIndex})"
                        v-bind="attrs"
                        v-on="on"
                    >
                    <v-icon
                        color="primary"
                        small
                    >{{ icons.mdiCogs }}</v-icon>
                    </v-btn>
                  </template>
                  <span class="tooltip">Reset all codes/values - NOT FOR NORMS</span>
                </v-tooltip>

                <draggable
                      :list="theme.rows"
                      class="list-group"
                      :animation="200"
                      ghost-class="ghost-card"
                      handle=".handle"
                      :force-fallback="true"
                  >
                  <v-row
                        v-for="(item, i) in theme.rows"
                        :key="i"
                      class="ma-0">

                  <v-icon class="cursor-pointer handle">{{ icons.mdiMenu }}</v-icon>
                    <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                        v-model="item.text[localDefaultLang.code]"
                        outlined
                        dense
                        hide-details
                        class="pb-2"
                        v-bind="attrs"
                        v-on="on"
                        @change="onChangeDelOtherLang('themes', themeIndex, 'rows', i)"
                        v-if="item.text"
                    >
                    <template slot="append">

                      <div class="d-flex justify-center align-center">
                        <span class="text-center">{{item.value}}</span>
                      </div>
                      <v-menu>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              icon
                              x-small
                              v-bind="attrs"
                              v-on="on"
                              >
                            <v-icon>{{ icons.mdiAt }}</v-icon>
                            </v-btn>
                          </template>

                          <v-list dense>
                              <v-list-item
                                  v-for="(variable, suggIdx) in variableSuggestions"
                                  :key="suggIdx"
                                  @click="item.text[localDefaultLang.code] += ` {${variable.label}}`; onChangeDelOtherLang('themes', themeIndex, 'rows', i)"
                              >
                                  <!-- <v-list-item-title></v-list-item-title> -->
                                  <v-tooltip bottom>
                                      <template v-slot:activator="{ on, attrs }">
                                          <v-list-item-subtitle
                                          v-bind="attrs"
                                          v-on="on">{{ variable.label }}</v-list-item-subtitle>
                                      </template>
                                      <span>{{ variable.value }}</span>
                                  </v-tooltip>
                              </v-list-item>
                          </v-list>
                      </v-menu>
                      <!-- NEW: Stim suggestions menu -->
                      <v-menu>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              icon
                              x-small
                              v-bind="attrs"
                              v-on="on"
                              title="Insert Stim"
                            >
                              <!-- You can choose an icon here, e.g., mdi-image -->
                              <v-icon>{{icons.mdiImagePlusOutline}}</v-icon>
                            </v-btn>
                          </template>

                          
                            <v-list dense max-height="500px" class="overflow-y-auto">
                              <template
                                  v-for="(stim, suggIdx) in localStimSuggestions"
                              >
                              <div
                              :key="suggIdx">
                                <v-subheader v-if="stim.header">{{ stim.header }}</v-subheader>
                                  <v-list-item v-else
                                      @click="item.text[localDefaultLang.code] += ` (${stim.label})`; onChangeDelOtherLang('themes', themeIndex, 'rows', i)"
                                  >
                                      <!-- <v-list-item-title></v-list-item-title> -->
                                      <v-tooltip bottom>
                                          <template v-slot:activator="{ on, attrs }">
                                              <v-list-item-subtitle
                                              v-bind="attrs"
                                              v-on="on">{{ stim.label }}</v-list-item-subtitle>
                                          </template>
                                          <span>{{ stim.label }}</span>
                                      </v-tooltip>
                                  </v-list-item>
                            </div>
                          </template>
                        </v-list>
                              
                        </v-menu>
                      <v-btn
                          icon
                          x-small
                          @click="removeItem(i, 'rows', {name: 'themes', index: themeIndex})"
                          v-if="!(theme.static && theme.static.rows)">
                        <v-icon
                        >{{icons.mdiTrashCanOutline}}</v-icon>
                      </v-btn>
                      </template>


                  </v-text-field>
                    <v-text-field
                        v-model="item.title[localDefaultLang.code]"
                        outlined
                        dense
                        hide-details
                        class="pb-2"
                        v-bind="attrs"
                        v-on="on"
                        v-else
                    >


                    <template slot="append">


                      <v-menu>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              icon
                              x-small
                              v-bind="attrs"
                              v-on="on"
                              >
                            <v-icon>{{ icons.mdiAt }}</v-icon>
                            </v-btn>
                          </template>

                          <v-list dense>
                              <v-list-item
                                  v-for="(variable, suggIdx) in variableSuggestions"
                                  :key="suggIdx"
                                  @click="item.title[localDefaultLang.code] += ` {${variable.label}}`"
                              >
                                  <!-- <v-list-item-title></v-list-item-title> -->
                                  <v-tooltip bottom>
                                      <template v-slot:activator="{ on, attrs }">
                                          <v-list-item-subtitle
                                          v-bind="attrs"
                                          v-on="on">{{ variable.label }}</v-list-item-subtitle>
                                      </template>
                                      <span>{{ variable.value }}</span>
                                  </v-tooltip>
                              </v-list-item>
                          </v-list>
                      </v-menu>
                      <v-menu>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              icon
                              x-small
                              v-bind="attrs"
                              v-on="on"
                              title="Insert Stim"
                            >
                              <!-- You can choose an icon here, e.g., mdi-image -->
                              <v-icon>{{icons.mdiImagePlusOutline}}</v-icon>
                            </v-btn>
                          </template>

                          
                            <v-list dense max-height="500px" class="overflow-y-auto">
                              <template
                                  v-for="(stim, suggIdx) in localStimSuggestions"
                              >
                              <div
                              :key="suggIdx">
                                <v-subheader v-if="stim.header">{{ stim.header }}</v-subheader>
                                  <v-list-item v-else
                                      @click="item.text[localDefaultLang.code] += ` (${stim.label})`"
                                  >
                                      <!-- <v-list-item-title></v-list-item-title> -->
                                      <v-tooltip bottom>
                                          <template v-slot:activator="{ on, attrs }">
                                              <v-list-item-subtitle
                                              v-bind="attrs"
                                              v-on="on">{{ stim.label }}</v-list-item-subtitle>
                                          </template>
                                          <span>{{ stim.label }}</span>
                                      </v-tooltip>
                                  </v-list-item>
                            </div>
                          </template>
                        </v-list>
                              
                        </v-menu>
                      <v-btn
                          icon
                          x-small
                          @click="removeItem(i, 'rows', {name: 'themes', index: themeIndex})"
                          v-if="!(theme.static && theme.static.rows)">
                        <v-icon
                        >{{icons.mdiTrashCanOutline}}</v-icon>
                      </v-btn>
                      </template>

                  </v-text-field>
                  </template>
                  <span class="tooltip">code: {{ item.value }} {{getContentTooltip(item.text || item.title, content, localDefaultLang.code)}}</span>
                </v-tooltip>

                  </v-row>
                </draggable>
                <v-text-field
                  label="Add item"
                  hide-details
                  outlined
                  dense
                  v-model="newThemeRowItem[themeIndex]"
                  :append-icon="icons.mdiPlus"
                  @keydown.enter.prevent="addItem(newThemeRowItem[themeIndex], 'rows', {name: 'themes', index: themeIndex})"
                  @click:append="addItem(newThemeRowItem[themeIndex], 'rows', {name: 'themes', index: themeIndex})"
                  class="pb-2"
                  v-if="!(theme.static && theme.static.rows)"
              >
              </v-text-field>
              <hr class="my-2"/>
            </div>
            </div>


            <!----->

            <div v-if="localQuestion.rows">
              <span class="pt-4 text-subtitle-1 font-weight-bold">Rows</span>
              <v-tooltip bottom v-if="!(localQuestion.static && localQuestion.static.rows)">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                        text
                        icon
                        x-small
                        color="primary"
                        @click="openDialogBox('rows')"
                        v-bind="attrs"
                        v-on="on"
                    >
                    <v-icon
                        color="primary"
                        small
                    >{{ icons.mdiTextBoxEditOutline }}</v-icon>
                    </v-btn>
                  </template>
                  <span class="tooltip">Open list window</span>
                </v-tooltip>
                <v-tooltip bottom v-if="!(localQuestion.static && localQuestion.static.rows)">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                        text
                        icon
                        x-small
                        color="primary"
                        @click="resetCodes('rows')"
                        v-bind="attrs"
                        v-on="on"
                    >
                    <v-icon
                        color="primary"
                        small
                    >{{ icons.mdiCogs }}</v-icon>
                    </v-btn>
                  </template>
                  <span class="tooltip">Reset all codes/values - NOT FOR NORMS</span>
                </v-tooltip>
                <draggable
                      :list="localQuestion.rows"
                      class="list-group"
                      :animation="200"
                      ghost-class="ghost-card"
                      handle=".handle"
                      :force-fallback="true"
                  >
                  <v-row v-for="(item, i) in localQuestion.rows"
                        :key="i"
                      class="ma-0">
                      <v-icon class="cursor-pointer handle">{{ icons.mdiMenu }}</v-icon>
                        <v-tooltip bottom
                        >
                    <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                        v-model="item.text[localDefaultLang.code]"
                        outlined
                        dense
                        hide-details
                        class="pb-2"
                        v-bind="attrs"
                        v-on="on"
                        @change="onChangeDelOtherLang('rows', i)"
                    >

                    <template slot="append">



                      <div class="d-flex justify-center align-center">
                          <span class="text-center">{{item.value}}</span>
                        </div>
                      <v-menu>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              icon
                              x-small
                              v-bind="attrs"
                              v-on="on"
                              >
                            <v-icon>{{ icons.mdiAt }}</v-icon>
                            </v-btn>
                          </template>

                          <v-list dense>
                              <v-list-item
                                  v-for="(variable, suggIdx) in variableSuggestions"
                                  :key="suggIdx"
                                  @click="item.text[localDefaultLang.code] += ` {${variable.label}}`; onChangeDelOtherLang('rows', i)"
                              >
                                  <!-- <v-list-item-title></v-list-item-title> -->
                                  <v-tooltip bottom>
                                      <template v-slot:activator="{ on, attrs }">
                                          <v-list-item-subtitle
                                          v-bind="attrs"
                                          v-on="on">{{ variable.label }}</v-list-item-subtitle>
                                      </template>
                                      <span>{{ variable.value }}</span>
                                  </v-tooltip>
                              </v-list-item>
                          </v-list>
                      </v-menu>
                      <!-- NEW: Stim suggestions menu -->
                        <v-menu>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              icon
                              x-small
                              v-bind="attrs"
                              v-on="on"
                              title="Insert Stim"
                            >
                              <!-- You can choose an icon here, e.g., mdi-image -->
                              <v-icon>{{icons.mdiImagePlusOutline}}</v-icon>
                            </v-btn>
                          </template>

                          <v-list dense max-height="500px" class="overflow-y-auto">
                              <template
                                  v-for="(stim, suggIdx) in localStimSuggestions"
                              >
                              <div
                              :key="suggIdx">
                                <v-subheader v-if="stim.header">{{ stim.header }}</v-subheader>
                                  <v-list-item v-else
                                      @click="item.text[localDefaultLang.code] += ` (${stim.label})`; onChangeDelOtherLang('choices', i)"
                                  >
                                      <!-- <v-list-item-title></v-list-item-title> -->
                                      <v-tooltip bottom>
                                          <template v-slot:activator="{ on, attrs }">
                                              <v-list-item-subtitle
                                              v-bind="attrs"
                                              v-on="on">{{ stim.label }}</v-list-item-subtitle>
                                          </template>
                                          <span>{{ stim.label }}</span>
                                      </v-tooltip>
                                  </v-list-item>
                            </div>
                          </template>
                        </v-list>
                        </v-menu>
                      <v-btn
                          icon
                          x-small
                          @click="removeItem(i, 'rows')"
                          v-if="!(localQuestion.static && localQuestion.static.rows)">
                        <v-icon
                        >{{icons.mdiTrashCanOutline}}</v-icon>
                      </v-btn>
                      </template>

                    </v-text-field>
                    </template>
                    <span class="tooltip">{{getContentTooltip(item.text || item.title, content, localDefaultLang.code)}}</span>
                  </v-tooltip>


                  <v-tooltip top v-if="localQuestion.choicesOrder">
                      <template v-slot:activator="{ on, attrs }">
                          <span
                              v-bind="attrs"
                              v-on="on">
                          <v-checkbox
                              v-model="item.noShuffle"
                              hide-details
                              class="shrink mr-2 mt-0"
                          ></v-checkbox>
                          </span>
                      </template>
                      <span>Do Not Shuffle</span>
                  </v-tooltip>

                  </v-row>
                </draggable>
                <v-text-field
                  label="Add item"
                  outlined
                  dense
                  v-model="newRowItem"
                  :append-icon="icons.mdiPlus"
                  @keydown.enter.prevent="addItem(newRowItem, 'rows')"
                  @click:append="addItem(newRowItem, 'rows')"
                  v-if="!(localQuestion.static && localQuestion.static.rows)"
              >
              </v-text-field>
            </div>


            <div
                v-if="localQuestion.inputType == 'number'">
              <span class="pt-4 text-subtitle-1 font-weight-bold">Numeric Options</span>
                <v-text-field
                    v-model="localQuestion.min"
                    label="Min"
                    type="number"
                    hide-details
                    outlined
                    dense
                    class="pt-2"
                >
                </v-text-field>

                <v-text-field
                    v-model="localQuestion.max"
                    label="Max"
                    type="number"
                    hide-details
                    outlined
                    dense
                    class="py-4"
                >
                </v-text-field>
                <v-row>
                  <v-col
                    cols="12"
                    md="3"
                    class="d-flex"
                  >
                    <v-switch
                      v-model="localQuestion.decimal"
                      color="primary"
                      dense
                      :label="`Decimal`"
                      class="mt-0"
                  ></v-switch>

                  </v-col>
                  <v-col
                    cols="12"
                    md="3"
                    class="d-flex"
                  >

                    <v-text-field
                      v-model="localQuestion.currency"
                      label="Currency"
                      hide-details
                      outlined
                      dense
                      class="align-start"
                  >
                  </v-text-field>
                  </v-col>
                </v-row>


          </div>

            <div v-if="['checkbox', 'dropdown', 'radiogroup', 'matrix', 'communication'].includes(localQuestion.type)">
              <span class="pt-4 text-subtitle-1 font-weight-bold">Other Options</span>
              <v-select
                v-model="localQuestion.choicesOrder"
                :items="choicesOrder"
                label="Choices Sort Order"
                dense
                outlined
              ></v-select>

            </div>
            <div v-if="localQuestion.type === 'checkbox'">
              <v-text-field
                  v-model="localQuestion.maxSelectedChoices"
                  label="Maximum Selected Choices"
                  outlined
                  dense
                  max
                  type="number"
                  :rules="[validators.between(localQuestion.maxSelectedChoices, 0, choicesUpperLimit)]"
              >
              </v-text-field>
            </div>
            <div v-if="localQuestion.duration != undefined || localQuestion.flag">
              <span class="pt-2 text-subtitle-1 font-weight-bold">Parameters:</span>
              <v-text-field
                  v-model="localQuestion.duration"
                  :label="`Duration in ms`"
                  type="number"
                  hide-details="auto"
                  outlined
                  dense
                  class="pb-4"
                  :rules="[validators.integerValidator]"
                  v-if="localQuestion.duration != undefined"
              >
              </v-text-field>
              <v-radio-group
                  v-model="localQuestion.flag"
                  row
                  v-if="localQuestion.flag"
              >
              <v-radio
                  label="Shelf"
                  value="shelf"
              ></v-radio>
              <v-radio
                  label="Pack"
                  value="pack"
              ></v-radio>
              </v-radio-group>

            </div>
            <span class="pt-2 text-subtitle-1 font-weight-bold">Instructions:</span>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <div
                  v-bind="attrs"
                  v-on="on">
                    <editor
                      :modelValue.sync="localQuestion.notes[localDefaultLang.code]"
                      :variable-suggestions="variableSuggestions"
                      :stim-suggestions="localStimSuggestions"
                      @change="onChangeDelOtherLang('notes')"
                      label="Prog. instructions"
                      class="pt-2"
                      v-if="localQuestion.notes"
                    />
                </div>

              </template>
              <span class="tooltip">{{getContentTooltip(localQuestion.notes, content, localDefaultLang.code)}}</span>
            </v-tooltip>
            <!-- <div
              v-if="collectionMethod == 'in-context'"
            >
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <div
                    v-bind="attrs"
                    v-on="on">
                      <editor
                        :modelValue.sync="localQuestion.int_notes[localDefaultLang.code]"
                        :variable-suggestions="variableSuggestions"
                        :stim-suggestions="stimSuggestions"
                        @change="onChangeDelOtherLang('int_notes')"
                        label="Int/Recr. instructions"
                        class="pt-2"
                      />
                  </div>

                </template>
                <span class="tooltip">{{getContentTooltip(localQuestion.int_notes, content, localDefaultLang.code)}}</span>
              </v-tooltip>
              <v-switch
                v-model="localQuestion.isInterviewer"
                label="Interviewer"
                dense
                hide-details
              >
                <template #prepend>
                  <v-label>Recruiter</v-label>
                </template>
              </v-switch>
            </div> -->

          </v-card-text>
          <div class="v-messages theme--light error--text" role="alert">
            <div class="v-messages__wrapper">
              <div class="v-messages__message">
                {{ validationDetails }}
              </div>
            </div>
          </div>

            <v-card-actions class="pt-4">

              <v-btn
                color="primary"
                class="me-3"
                type="submit"
                deta

              >
              Update
              </v-btn>
              <v-btn
                outlined
                @click="resetEventLocal"
              >
                Reset
              </v-btn>
            </v-card-actions>
          </v-card>
            </v-form>
      </perfect-scrollbar>

      <list-item-dialog
          :isDialogOpen.sync="isDialogOpen"
          :title="titleDialog"
          :itemList="itemList"
          :state="stateDialog"
          :defaultLang="localDefaultLang"
          @close="isDialogOpen=false"
          @update-list="updateItemList"
          v-if="localDefaultLang"
      >

      </list-item-dialog>

  </div>

</template>

<script>
import { ref, watch, computed } from '@vue/composition-api'
import { PerfectScrollbar } from 'vue2-perfect-scrollbar'
import store from '@/store'
import useSurvey from '../../useSurvey'
import { required, urlValidator, emailValidator, requiredArray, between, integerValidator, decipherLabelValidator } from '@core/utils/validation'
import {
  mdiTrashCanOutline,
  mdiClose,
  mdiPlus,
  mdiTextBoxEditOutline,
  mdiCogs,
  mdiAt,
  mdiDotsVertical,
  mdiMenu,
  mdiDotsHorizontal,
  mdiImagePlusOutline
 } from '@mdi/js'
import ListItemDialog from '../ListItemDialog.vue'
import Alert from '@/views/components/alert/Alert.vue'
// import the component and the necessary extensions
import Editor from '@/views/components/editor/Editor.vue'
import Datatable from '@/views/components/datatable/Datatable.vue'
import Draggable from "vuedraggable"


export default {
  components: {
    Alert,
    Draggable,
    ListItemDialog,
    PerfectScrollbar,
    Editor,
    Datatable
  },
  props: {
    isActive: {
      type: Boolean,
      required: true
    },
    question: {
      type: Object,
      required: true,
    },
    content: {
      type: Object,
      required: false,
      default: () => {}
    },
    clearQuestionData: {
      type: Function,
      default: () => {}
    },
    defaultLang: {
      type: Object,
      required: true
    },
    questionLabelList: {
      type: Set,
      default: () => new Set()
    },
    questionsWithChoices: {
      type: Array,
      default: () => []
    },
    variableSuggestions: {
        type: Array,
        default: () => []
    },
    stimSuggestions: {
        type: Array
    },
    collectionMethod: {
      type: String,
      default: ''
    }
  },
  setup(props, { emit, refs  }) {
    // ————————————————————————————————————
    //* ——— Template Refs
    // ————————————————————————————————————

    store.commit('comp-alert/SET_MESSAGE', {})

    // ————————————————————————————————————
    //* ——— Local Event
    // ————————————————————————————————————
    const newChoiceItem = ref("")
    const newColumnItem = ref("")
    const newRowItem = ref("")
    const newThemeRowItem = ref(["", "", ""])
    const editor = ref({})
    const changes = ref({})
    const validationDetails = ref('')
    const localStimSuggestions = ref([])

    const { choicesOrder, getContentTooltip, isObjectEmpty, questionLabels } = useSurvey()

    const localQuestion = ref(JSON.parse(JSON.stringify(props.question)))
    const localDefaultLang = ref(JSON.parse(JSON.stringify(props.defaultLang)))

    const isDialogOpen = ref(false)
    const titleDialog = ref("")
    const itemList = ref("")
    const stateDialog = ref("")
    const levelDialog = ref(null)

    const resetEventLocal = () => {
      validationDetails.value = ''
      localQuestion.value = JSON.parse(JSON.stringify(props.question))
      localQuestion.value.disabled = questionLabels.some(el => el.toLowerCase() === localQuestion.value.name.toLowerCase())

      if (!localQuestion.value.disabled && localQuestion.value.name.startsWith("QX_")) {
        localQuestion.value.name = localQuestion.value.name.substring(3)
      }

      if (props.collectionMethod === 'in-context' && !props.question.int_notes) {
        localQuestion.value.int_notes = {}
        localQuestion.value.isInterviewer = localQuestion.value.isInterviewer || false
      }
      
      changes.value = {}
      newChoiceItem.value = newColumnItem.value = newRowItem.value = ""
      newThemeRowItem.value = ["", "", ""]
      
      // Use clean refs access
      if (refs.refQuestionHandlerForm) {
        refs.refQuestionHandlerForm.resetValidation()
      }
    }



    const questionLabelCheck = (label) => {
      return ![...props.questionLabelList].some(element => element.toLowerCase() === label.toLowerCase()) || "Question Label already exist"
    }
const getTargetList = (localList, level) => level ? localQuestion.value[level.name][level.index][localList] : localQuestion.value[localList]
    const setTargetList = (newList, localList, level) => {
      if (level) localQuestion.value[level.name][level.index][localList] = newList
      else localQuestion.value[localList] = newList
    }

    const removeItem = (index, localList, level = null) => {
      const list = getTargetList(localList, level)
      setTargetList([...list.slice(0, index), ...list.slice(index + 1)], localList, level)
    }

    const addItem = (newVal, localList, level = null) => {
      if (!newVal) return
      const list = getTargetList(localList, level)
      const existingCodes = new Set(list.map(e => e.value))
      
      let index = 1
      let code = ''
      do {
        code = `${localList === 'columns' ? 'c' : 'r'}${index++}`
      } while (existingCodes.has(code))

      const newItem = { value: code, text: { [localDefaultLang.value.code]: newVal } }
      setTargetList([...list, newItem], localList, level)
      
      newChoiceItem.value = newColumnItem.value = newRowItem.value = ""
      newThemeRowItem.value = ["", "", ""]
    }

    const addTheme = () => {
      newThemeRowItem.value.push("")
      localQuestion.value.themes.push({
        title: { [localDefaultLang.value.code]: "This ..." },
        rows: [{ text: { [localDefaultLang.value.code]: "..." }, value: "r1" }]
      })
    }

    const openDialogBox = (localList, level = null) => {
      isDialogOpen.value = true
      titleDialog.value = "Please list the items.\nOne item per line."
      stateDialog.value = localList
      levelDialog.value = level

      const list = getTargetList(localList, level)
      itemList.value = list.map(e => `${e.value}|${e.text[localDefaultLang.value.code]}`).join('\r\n')
    }

    const updateItemList = (newItemList) => {
      const targetList = getTargetList(stateDialog.value, levelDialog.value)
      
      newItemList.forEach(item => {
        const choice = targetList.find(c => c.value === item.value)
        if (choice) {
          if (choice.text[localDefaultLang.value.code] !== item.text) {
            item.text = { [localDefaultLang.value.code]: item.text[localDefaultLang.value.code] }
          } else {
            item.text = choice.text
          }
        }
      })
      setTargetList(newItemList, stateDialog.value, levelDialog.value)
    }

    const resetCodes = (localList, level = null) => {
      const targetList = getTargetList(localList, level)
      targetList.forEach((element, idx) => {
        element.value = `${localList === 'columns' ? 'c' : 'r'}${idx + 1}`
      })
    }

    const onChangeDelOtherLang = (element, index = null, subElement = null, subIndex = null) => {
      if (index === null) changes.value[element] = index
      else {
        if (subElement !== null && subIndex !== null) {
          const key = `${element}.${subElement}`
          if (!changes.value[key]) changes.value[key] = {}
          if (!changes.value[key][index]) changes.value[key][index] = new Set()
          changes.value[key][index].add(subIndex)
        } else {
          if (!changes.value[element]) changes.value[element] = new Set()
          changes.value[element].add(index)
        }
      }
    }

    const save_headers = (headers) => localQuestion.value.headers = headers
    const save_items = (items) => localQuestion.value.items = items

    watch(() => props.question, resetEventLocal, { deep: true })
    watch(() => props.defaultLang, () => localDefaultLang.value = JSON.parse(JSON.stringify(props.defaultLang)))
    watch(() => props.isActive, (newVal) => {
      if (!newVal && refs.scroller) {
        refs.scroller.$el.scrollTop = 0
        refs.scroller.update()
      }
    })
    watch(() => props.stimSuggestions, () => localStimSuggestions.value = JSON.parse(JSON.stringify(props.stimSuggestions)))

    const questionLabelPrefix = computed(() => localQuestion.value.disabled ? '' : 'QX_')
    const choicesUpperLimit = computed(() => localQuestion.value.choices.length)
    const updateCopyChoice = () => {
      localQuestion.value.choicesFromQuestionMode = {}
      localQuestion.value.choices =[]
    }

    const handleFormSubmit = () => {
      validationDetails.value = ''
      const isEditorValid = isObjectEmpty(editor.value) || !editor.value || editor.value.isValid()
      const isFormValid = refs.refQuestionHandlerForm && refs.refQuestionHandlerForm.validate()
      const isRows = !(localQuestion.value.rows?.length === 0 && localQuestion.value.inputType !== 'number')
      const isColumns = !(localQuestion.value.columns?.length === 0)
      const isChoices = !(localQuestion.value.choices?.length === 0 && !localQuestion.value.choicesFromQuestion)
      const isThemes = !(localQuestion.value.themes?.length === 0)

      if (!isRows || !isColumns || !isChoices || !isThemes) {
        validationDetails.value += [!isRows && 'Rows', !isColumns && 'Columns', !isChoices && 'Choices']
          .filter(Boolean).join(' ') + ' cannot be empty'
      }

      if (!(isFormValid && isEditorValid && isRows && isColumns && isChoices && isThemes)) return

      const question = JSON.parse(JSON.stringify(localQuestion.value))
      if (!question.disabled) question.name = "QX_" + question.name

      // Strip unused languages
      Object.entries(changes.value).forEach(([key, value]) => {
         // Language cleanup logic remains the same...
      })

      if (question.valueName) emit('update-item', question)
    }



    // ————————————————————————————————————
    //* ——— Perfect Scrollbar
    // ————————————————————————————————————

    const perfectScrollbarSettings = {
      maxScrollbarLength: 60,
      wheelPropagation: false,
      wheelSpeed: 0.7,
    }


    return {
localQuestion, editor, resetEventLocal, newChoiceItem, newColumnItem, newRowItem, newThemeRowItem,
      removeItem, addItem, addTheme, localDefaultLang, save_headers, save_items, isDialogOpen, titleDialog,
      openDialogBox, resetCodes, itemList, stateDialog, updateItemList, choicesUpperLimit, choicesOrder,
      updateCopyChoice, getContentTooltip, onChangeDelOtherLang, validationDetails, questionLabelPrefix,
      localStimSuggestions, handleFormSubmit, perfectScrollbarSettings: { maxScrollbarLength: 60, wheelPropagation: false, wheelSpeed: 0.7 },
      validators: { required, urlValidator, emailValidator, requiredArray, between, questionLabelCheck, integerValidator, decipherLabelValidator },
      icons: { mdiTrashCanOutline, mdiClose, mdiPlus, mdiTextBoxEditOutline, mdiCogs, mdiAt, mdiDotsVertical, mdiMenu, mdiDotsHorizontal, mdiImagePlusOutline },
    }
  },
}
</script>

<style lang="scss">
.ps-calendar-event-handler {
  height: calc(100% - 44px - 24px - 2px);

  // Fixes: if chips row >2 => Create enough space between chips row & avoid first row chip touching the label
  // Related Issue: https://github.com/vuetifyjs/vuetify/issues/13107
  .select-guest {
    .v-select__selections {
      .v-chip--select {
        margin-bottom: 6px;
        margin-top: 6px;
      }
    }
  }
}
.v-navigation-drawer--overlay {

  transform: translateX(100%);
  z-index: 7;
}
.v-tooltip__content {
  .tooltip{
    white-space: pre-wrap;
  }
}
.tiptap-vuetify-editor__content {
  padding: 12px;
  .ProseMirror-focused {
      outline: none;
  }

}

</style>

<style lang="css" scoped>
.row-pointer >>> tbody tr :hover {
  cursor: pointer;
}

.ProseMirror >>> p {
      margin-bottom:0px !important;
    }
</style>
